import { PackageIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { PackageContentEditorRenderer } from "./editor";
import { PackageContentEmailRenderer } from "./email";
import type { PackageContentBlockProps } from "./types";
import { PackageContentWeb } from "./web";
import { PackageContentWebEditor } from "./web-editor";
import { PackageContentEmailPanelRenderer } from "./email-panel";


export default registerBlock<PackageContentBlockProps>({
  type: "package-content",
  name: "editorBlocksLibrary.blocks.package-content.title",
  description: "editorBlocksLibrary.blocks.package-content.description",
  Icon: PackageIcon,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    email: {
      component: PackageContentEmailRenderer,
      editor: {
        component: PackageContentEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: PackageContentEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: PackageContentWeb,
      editor: {
        component: PackageContentWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: {
          minSize: 6,
        },
      },
    },
  },
});

export type { PackageContentBlockProps as PackageContentEditorRendererProps } from "./types";
